export function getShouldShowValidation(
  submitCount: number,
  touchedKeysLength: number,
  hasAttemptedSubmit: boolean
): boolean {
  return (
    hasAttemptedSubmit || submitCount > 0 || touchedKeysLength > 0
  );
}
